<template>
  <div>
    <v-row>
      <v-card class="rounded-lg white" width="100%">
        <v-card-title class="secondary white--text">
          <v-avatar v-if="order_package.business.logo" size="40" class="rounded-lg ml-3" color="#414A53">
            <v-img id="menu-activator" :src="img_source(order_package.business.logo)" max-width=40
                   max-height=40></v-img>
          </v-avatar>
          <span style="font-size: small">
            {{ order_package.business.business_type_display }} {{ order_package.business.name }}
          </span>
          <v-spacer></v-spacer>


          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  depressed
                  :href="printUrl"
                  target="_blank"
                  class="lightSecondary mr-md-2 "
              >
                <v-img max-height="25" max-width="25" src="/img/icons/print.svg"></v-img>
              </v-btn>
            </template>
            چاپ
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  depressed
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :href="pdfUrl"
                  target="_blank"

                  class="lightSecondary mr-2"
              >
                <v-img max-height="18" max-width="18" src="/img/icons/pdf.svg"></v-img>
              </v-btn>
            </template>
            خروجی PDF
          </v-tooltip>
        </v-card-title>
        <v-card-subtitle class="secondary white--text" style="font-size: x-small; margin-top: -5px">
          <span>
            مشتری :
          </span>
          <span>
            {{ order_package.customer_name }}
          </span>
          <span class="mr-2">
            شماره :
          </span>
          <span>
           {{ order_package.phone }}
          </span>
        </v-card-subtitle>
        <v-card-subtitle class="secondary white--text" style="font-size: x-small; margin-top: -30px">
          <span>
            کد پستی :
          </span>
          <span>
            {{ order_package.postal_code }}
          </span>
          <span class="mr-2">
            آدرس :
          </span>
          <span>
           {{ order_package.address }}
          </span>
        </v-card-subtitle>
        <v-card-text>
          <v-card width="100%" class="accent success--text rounded-lg pa-1 mt-1"
                  v-for="item in order_package_items">
            <v-avatar size="30" class="rounded-lg ml-3" color="#FFACC5" v-if="item.product.picture">
              <v-img id="menu-activator" :src="img_source(item.product.picture)" max-width=50 max-height="50"></v-img>
            </v-avatar>
            <span class="success--text  font-weight-bold" style="font-size: xx-small">
            نام :
          </span>
            <span  style="font-size: xx-small" v-if="item.product.name">
            {{ item.product.name }}
          </span>
            <br>
            <span class="mr-11 font-weight-bold"  style="font-size: xx-small">
            تعداد :
          </span>
            <span  style="font-size: xx-small" v-if="item.quantity">
            {{ item.quantity }}
          </span>
            <span class="mr-5 font-weight-bold"  style="font-size: xx-small">
            کد قفسه :
          </span>
            <span  style="font-size: xx-small" v-if="item.product.shelf_code">
            {{ item.product.shelf_code }}
          </span>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-chip x-small style="font-size: xx-small" v-if="order_package.is_packaged"
          >بسته بندی در {{ order_package.packing_data_time }}</v-chip>
          <v-chip x-small style="font-size: xx-small" v-if="order_package.is_shipped"
          >ارسال در {{ order_package.shipping_data_time }}</v-chip>
          <template v-if="user.user_type == 'paad'">
          <v-btn v-if="!order_package.is_packaged" class="success white--text rounded-lg" depressed
                 @click="packedOrders">
            بسته بندی شد
          </v-btn>
          <v-btn v-else-if="!order_package.is_shipped" class="success white--text rounded-lg" depressed
                 @click="shippedOrders">
            پست شد
          </v-btn>
          </template>
        </v-card-actions>

      </v-card>
    </v-row>
  </div>

</template>

<script>

import {PathLevels, VisitorLevels} from "@/variables";
import cart from "@/components/scomponents/Cart";
import UserSelect from "@/components/selects/UserSelect";


export default {
  name: "OrderPackage",
  components: {
    UserSelect,
    cart
  },

  props: {
    id: {},
  },
  data() {
    return {
      permissionBasename: "order_package",
      appendSlash: false,
      payFromWallet: false,
      order_package: {},
      order_package_items: [],
      hasList: false,
      discountCode: "",
      discountAmount: 0,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      admin: null,
      isDefinable: false,
      pay_amount: 0,
      myClass: '',
      ss: null,
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      first: false,
      cols: [
        {
          text: "نام کسب و کار",
          value: "business.name",
        },
        {
          text: "نام مشتری",
          value: "customer_name",
        },
        {
          text: "تلفن",
          value: "phone",
        },
        {
          text: "آدرس",
          value: "address",
        },
      ],

    };
  },
  computed: {
    title() {
      return ' سفارش'
    },
    headers() {
      return [];
    },
    printUrl() {
      let path = `packing/orderPackageExport/html?id=${this.id}&token=${this.token}`;
      return this.endpoint(path);
    },
    pdfUrl() {
      let path = `packing/orderPackageExport/pdf?id=${this.id}&token=${this.token}`;
      return this.endpoint(path);
    },

  },
  updated() {
  },
  mounted() {
    this.getOrderPackage()
  },
  methods: {
    getOrderPackage() {
      this.request({
        url: this.endpoint(`packing/getOrder/${this.id}`),
        method: "get",
        success: data => {
          this.order_package = data.response.order_package
          this.order_package_items = data.response.order_package_items
        }
      })
    },
    packedOrders() {
      this.request({
        url: this.endpoint(`packing/packedOrderPackages`),
        method: "post",
        data: {items: [this.id]},
        success: data => {
          this.successNotify()
          this.getOrderPackage()
        }
      })
    },
    shippedOrders() {
      this.request({
        url: this.endpoint(`packing/shippedOrderPackages`),
        method: "post",
        data: {items: [this.id]},
        success: data => {
          this.successNotify()
          this.getOrderPackage()
        }
      })
    },

  },
}
</script>

<style scoped lang="scss"></style>

